module.exports = __webpack_public_path__ + "img/user-position-red-highres.b3d572be.png";